import isEmpty from 'lodash.isempty';
import { BOOTSTRAPPING_SUCCESS } from '../actions/user';
import { CREATE_RESOURCE_CREDENTIALS_SUCCESS } from '../actions/auth';

export const createRollbarMiddleware = () => (/* store */) => next => action => {
  switch(action.type) {
    case CREATE_RESOURCE_CREDENTIALS_SUCCESS:
    case BOOTSTRAPPING_SUCCESS: {
      const user = action.data
        && action.data.user
        && Object.values(action.data.user).length
        && Object.values(action.data.user)[0];
      if (!user) {
        break;
      }
      let person = {
        id: user.id,
        username: user.attributes && user.attributes.name,
        firstname: user.attributes && user.attributes.firstName,
        lastname: user.attributes && user.attributes.lastName,
        email: user.attributes && user.attributes.email,
        intercom: `https://app.intercom.io/apps/${process.env.REACT_APP_INTERCOM_APP_ID}/users/show?user_id=${user.id}`,
      };
      const profile = getProfile(action.data);
      if (!isEmpty(profile)) {
        person = {
          ...person,
          school: profile.attributes && profile.attributes.activeSchoolName,
          company: isMentor(action.data) ?
            profile.attributes && profile.attributes.companyName
            : getEmployeeCompanyName(action.data),
        };
      }
      window.Rollbar?.configure({
        payload: { person },
      });
      break;
    }
  }
  return next(action);
};

/**
 * All these utils is only create for this feature !
 * No need to put them on separate util
 */
const isMentor = data => data && !!data.profileMentor;
const isAmbassador = data => data && !!data.profileEmployee;
const isStudent = data => data && !!data.profileStudent;
const getProfile = (data) => {
  if (isMentor(data)) {
    return Object.values(data.profileMentor)[0];
  }
  if (isAmbassador(data)) {
    return Object.values(data.profileEmployee)[0];
  }
  if (isStudent(data)) {
    return Object.values(data.profileStudent)[0];
  }
  return {};
};

const getEmployeeCompanyName = data => {
  return data.company
    && Object.values(data.company)
    && Object.values(data.company)[0].attributes
    && Object.values(data.company)[0].attributes.name;
};
